import { type ExWindow } from '@ve/types';

declare let window: ExWindow;

const ANNIVERSARY_LANDING_URL = '/15years';
const MAIN_PAGE_URL = '/';

const LOGO_SELECTOR = '.picture-travelata-logo, .headerTravelataLogo';

const isMainPage = (): boolean => window.location.pathname === MAIN_PAGE_URL;

export const initAnniversaryLogoClick = (): void => {
    document.addEventListener(
        'click',
        (event) => {
            if (!window.appConfig?.anniversary15Logo) {
                return;
            }

            const eventTarget = event.target;

            if (!(eventTarget instanceof Element) || !eventTarget.closest(LOGO_SELECTOR)) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            window.location.href = isMainPage() ? ANNIVERSARY_LANDING_URL : MAIN_PAGE_URL;
        },
        true,
    );
};
